import './jquery-ui.less';

import $ from 'jquery';
import 'jquery-ui/ui/jquery.ui.core';
import 'jquery-ui/ui/jquery.ui.widget';
import 'jquery-ui/ui/jquery.ui.mouse';
import 'jquery-ui/ui/jquery.ui.position';
import 'jquery-ui/ui/jquery.ui.draggable';
import 'jquery-ui/ui/jquery.ui.resizable';
import 'jquery-ui/ui/jquery.ui.autocomplete';
import 'jquery-ui/ui/jquery.ui.button';
import 'jquery-ui/ui/jquery.ui.datepicker';
import 'jquery-ui/ui/i18n/jquery.ui.datepicker-de';
import 'jquery-ui/ui/i18n/jquery.ui.datepicker-en-GB';
import 'jquery-ui/ui/jquery.ui.dialog';
import 'jquery-ui/ui/jquery.ui.menu';
import 'jquery-ui/ui/jquery.ui.slider';
import 'jquery-ui/ui/jquery.ui.effect';
import 'jquery-ui/ui/jquery.ui.effect-slide';

/**
 * Highlights matching text in autocomplete results
 */
$.extend($.ui.autocomplete.prototype, {
    _renderItem: function (ul, item) {
        const term = this.element.val();
        const html = item.label.replace(term, `<strong>${term}</strong>`);

        return $('<li>')
            .data('item.autocomplete', item)
            .append($('<a>').html(html))
            .appendTo(ul);
    },

    _resizeMenu: function () {
        const ul = this.menu.element;
        ul.outerWidth(this.element.outerWidth());
    }
});

/**
 * Sets locale for datepicker
 */
const { config } = window.POne;
const datepickerLocale = (config.culture !== 'de') ? 'en-GB' : config.culture;
const datepickerRegionalDefaults = $.datepicker.regional[datepickerLocale];
$.datepicker.setDefaults(datepickerRegionalDefaults);


// WEBPACK FOOTER //
// ./init/jquery-ui.js